import { get, remove } from './index';
import { env, ENV_DEV, DEV_DEBUG } from '../config/env';

const DEBUG = (env === ENV_DEV) && DEV_DEBUG;

export const getAppInit = () => {

	const endpoint = `catalog/app_init`;
	return get(endpoint);
}

export const logout = () => {
	const endpoint = `v1/users/logout`;
	if (!DEBUG) return remove(endpoint);

	console.log('[DELETE]', endpoint); //eslint-disable-line no-console
}
